import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const org_roles = {
    "Organisational Admin List": {
        selected: false,
    },
    "Create Organisational Admin": {
        selected: false,
    },
    "Case Manager List": {
        selected: false,
    },
    "Create Case Manager": {
        selected: false,
    },
    "Patient List": {
        selected: false,
    },
    "Create Patient": {
        selected: false,
    },
    "Organisation List": {
        selected: false,
    },
    "Create Organisation": {
        selected: false,
    },
};
export const clinical_roles = {
    "Program List": {
        selected: false,
    },
    "Create Program": {
        selected: false,
    },
};

export const FormikObj = {
    initialValues: {
        name: "",
        description: "",
        organization: "",
        isDefault: false,
    },
    validationSchema: Yup.object({
        name: conditionalValidation(
            Yup.string()
            .max(30, "Must be 30 characters or less")
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Name",
                mandatory: true
            }),
        description: conditionalValidation(
            Yup.string()
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
            {
                mandatory: true,
                validation,
                label:"Description"
            }),
        organization: conditionalValidation(
                Yup.string().when("isDefault", (isDefault, schema) =>
                    isDefault
                        ? schema
                        : Yup.string().max(30, "Must be 30 characters or less")
                            .required("Required organization field")
                            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")),
                    {
                        validation,
                        label: "Organization"
                    }),
    }),
}

export const FormikObjEdit = {
    initialValues: {
        id: "",
        name: "",
        description: "",
    },
    validationSchema: Yup.object({
        id: conditionalValidation(
            Yup.string().max(30, "Must be 30 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true
            }),
        name: conditionalValidation(
            Yup.string().max(30, "Must be 30 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                label: "Name",
                mandatory: true,
                validation
            }),
        description: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                mandatory: true,
                label: "Description",
                validation
            })
    }),
}